export enum PickerType {
  PRODUCTION_LINE = 0,
  PRODUCT,
  HARDWARE_CONFIGURATION,
  PATTERN,
  SOFTWARE_CONFIGURATION,
  ROBOT_CONFIGURATION,
  ROBOT_LICENSE,
}
